import { connect } from "react-redux";
import { Creators, getSearchResult, isAdmin } from "../../reducer";
import SearchCustomer from "./SearchCustomer";

export default connect(
  state => ({
    searchResult: getSearchResult(state),
    isAdmin: isAdmin(state)
  }),
  dispatch => ({
    onSearchCustomer: keyword =>
      dispatch(Creators.searchCustomer(keyword, ["phone", "email"])),
    onClearSearchCustomerResult: () =>
      dispatch(Creators.clearSearchCustomerResult())
  })
)(SearchCustomer);



// WEBPACK FOOTER //
// ./src/customer/components/SearchCustomer/index.js